import { render, staticRenderFns } from "./Historytable.vue?vue&type=template&id=02aa4ce6"
import script from "./Historytable.vue?vue&type=script&lang=js"
export * from "./Historytable.vue?vue&type=script&lang=js"
import style0 from "./Historytable.vue?vue&type=style&index=0&id=02aa4ce6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports